<template>
	<div class="works_content" v-loading="loading">
		<Breadcrumb />
		<el-container class="main_box" id="works">
			<el-main class="main_info" v-if="isworks">
				<ul class="works_list clearfix">
					<li class="works_li" v-for="(e, i) in MenuList" :key="i" @click="
              RouteGo('AboutsStatistics', { id: e.id }), setSessionB(e)
            ">
						<div class="works_left">
							<div class="works_title">{{ e.organization_name }}</div>
							<div class="works_text">成立时间: {{e.establish_time}}</div>
						</div>
						<div class="jtt">

						</div>
						<!-- <p>
              成立时间:{{ e.establish_time }}
            </p> -->
					</li>
				</ul>
				<div v-if="MenuList.length === 0 && !loading" style="text-align: center; font-size: 24px; padding: 20%">
					您当前尚未创建任何下属支部，<br /><span style="color: #f44">请拨打电话（0816）2370266开通支部功能</span>
				</div>
			</el-main>
			<el-main v-else>
				<el-container>
					<el-aside class="works_side" width="14%">
						<div class="shadow_box hc_card">
						
							<!-- <h3>{{SideTitle}}</h3> -->
							<Sidebar />
						</div>
					</el-aside>
					<el-main class="nopadding">
						<router-view></router-view>
					</el-main>
				</el-container>
			</el-main>
		</el-container>
	</div>
</template>
<script>
	import Sidebar from "@/components/Sidebar";
	import Breadcrumb from "@/components/Breadcrumb";
	import {
		getsBranchApi
	} from "@/network/api/branch";
	export default {
		data() {
			return {
				loading: true,
				isworks: true,
				MenuList: [],
				SideTitle: null,
			};
		},
		watch: {
			$route(to, from) {
				this.isworks = to.meta.moudles === true ? true : false;
				//console.log(to.meta.title)
			},
		},
		components: {
			Sidebar,
			Breadcrumb
		},
		methods: {
			setSessionB(e) {
				// console.log(e)
				this.$setSession("BranchId", e.id)
			},
			getMeta() {
				this.isworks = this.$route.meta.moudles === true ? true : false;
			},
			topath(url) {
				this.$router.push(url);
			},
			async getsBranch() {
				// let res = await getsBranchApi();
				const res = await this.PublicApi(
                        "admin/v3/getOrganization",

                    )
				this.MenuList = res.data
				this.loading = false;
			},
		},
		created() {
			this.getMeta();
			this.getsBranch();
			//console.log(this.$route.meta.title)
		},
	};
</script>
<style scoped="scoped">
	.works_content {
		background-image: url(../../assets/images/bbg.png);
		background-size: cover;
		background-position: bottom;
		background-repeat: no-repeat;
	}

	.works_list {}

	.works_li {
		display: flex;
		display: -webkit-flex;
		display: -ms-flexbox;
		justify-content: space-between;
		width: 32%;
		height: 100px;
		border-radius: 35px;
	}

	.works_left {
		flex: 1;
		padding-right: 15px;
		padding-left: 25px;
		display: flex;
		display: -webkit-flex;
		display: -ms-flexbox;
		flex-direction: column;
		justify-content: center;
	}

	.jtt {
		background-image: url(../../assets/images/jtt.png);
		    width: 50px;
		    height: 100%;
		    padding-right: 0px;
		    display: -webkit-box;
		    display: flex;
		    display: -ms-flexbox;
		    background-repeat: no-repeat;
		    background-position-y: 50%;
		    background-size: 35px;
	}

	.works_title {
		font-size: 24px;
		font-weight: bold;
		color: red;
	}

	.works_text {
		font-size: 15px;
		margin-top: 15px;
	}
</style>



// WEBPACK FOOTER //
// src/views/Branch/index.vue